module.exports = __webpack_public_path__ + "img/unfinished.73eaa0d7.png";